import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_RATES = [
  { key: "telkomsel", name: "Telkomsel", rate: 85 },
  { key: "xl_axis", name: "XL / Axis", rate: 89 },
  { key: "three", name: "Three", rate: 83 },
  { key: "indosat", name: "Indosat", rate: 83 },
  { key: "smartfren", name: "Smartfren", rate: 74 },
];

export const DEFAULT_SETTINGS = {
  whatsapp: "",
  email: "",
  hours: "",
  announcement: "",
  playstore_url: "https://play.google.com/store/apps/details?id=com.bagipulsa",
  playstore_enabled: true,
  appstore_url: "",
  appstore_enabled: false,
};

export const useSiteData = () => {
  const [data, setData] = useState({ rates: DEFAULT_RATES, settings: DEFAULT_SETTINGS, content: {}, gacha: false });
  useEffect(() => {
    if (!process.env.REACT_APP_BACKEND_URL) return undefined;
    let alive = true;
    api
      .get("/public")
      .then((res) => {
        if (!alive) return;
        const rates = Array.isArray(res.data?.rates) && res.data.rates.length ? res.data.rates : DEFAULT_RATES;
        setData({ rates, settings: { ...DEFAULT_SETTINGS, ...(res.data?.settings || {}) }, content: res.data?.content || {}, gacha: !!res.data?.gacha_enabled });
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return data;
};
